{
  "top-salons-city-page": {
    "text": {
      "no-salon-found": "No salons found in this city yet."
    },
    "meta": {
      "title": "Top salons in {{ city }}",
      "description": "Discover and book the best-rated beauty salons in {{ city }}. Compare top salons, check availability and book your appointment online in minutes."
    }
  }
}
